import React, { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Collapse } from 'reactstrap';
import { useFormState } from 'react-final-form';

import WpButton from 'Wpds/components/button/WpButton';
import WpIcon from 'Wpds/components/icon/WpIcon';

import { supportArticles } from './constants';
import ArticleLink from './ArticleLink/ArticleLink';
import './SupportArticles.scss';

function SupportArticles() {
  const [showArticles, setShowArticles] = useState(true);
  const itemsLength = useSelector(state => state.search?.itemsLength);
  const { values } = useFormState();

  useEffect(() => {
    if (!itemsLength || !values.searchStr) setShowArticles(true);
    else setShowArticles(false);
  }, [values.searchStr, itemsLength]);

  const toggleShowArticles = useCallback(() => setShowArticles(state => !state), []);

  return (
    <div className="SupportArticles px-4 py-2">
      <div className="mb-2">
        <WpButton variant="tertiary" onClick={toggleShowArticles}>
          <WpIcon name={showArticles ? 'chevron-down' : 'chevron-right'} />
          Support Articles from The PI Perform team
        </WpButton>
      </div>
      <Collapse isOpen={showArticles}>
        {supportArticles.map(article => (
          <ArticleLink key={article.url} {...article} />
        ))}
      </Collapse>
    </div>
  );
}

export default SupportArticles;
